import React from "react";
import {Route, Routes} from "react-router-dom"
import Navbar from "./components/navigation/navbar";
import Home from "./pages/Home";
import Sponsor from "./pages/Sponsor";
import History from "./pages/History";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Info from "./pages/Info";
import Logo25 from "./images/MDM-Logo.png";
import './App.css';
import Logo from "./images/mdm2025.png";
import Explore from "./pages/Explore";
import 'normalize.css';
import Banner from "./components/Banner";

// import Gallery from "./pages/Gallery";


const App = () => {

    return (
        <>
            <head>
                <meta charSet="UTF-8" />
                <link rel="icon" href="public/team/MDM-logo-general-circle.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta property="og:title" content="MDM" />\
                <meta name="description" content="Medical Device Make-A-Thon is a student lead competition" />
                <meta name="author" content="Haley Perez. Modified by Mia Chapin"/>
            </head>
            <Banner />

            {/* <div className="page-wrapper"> */}

            <Navbar />
            <div className="container">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/sponsor" element={<Sponsor />} />
                    {/*<Route path="/explore" element={<Explore />} />*/}
                    <Route path="/team" element={<Team />} />
                    <Route path="/history" element={<History />} />
                    <Route path="/team" element={<Team />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/previous-competitions" element={<Gallery />} />
                    <Route path="/info" element={<Info />} />
                </Routes>
            </div>

            {/* </div> */}

            <div className="footer">
                <div className="foot-section">
                    <p>National Medical Device Make-A-Thon 2026</p>
                    {/*https://www.instagram.com/medical_device_makeathon/*/}
                </div>
              
                <div className="foot-section">
                    <p>Hosted by the University of Texas at Austin</p>
                </div>
            </div>
        </>
    )
}

export default App;
